import { split86012String } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';
import { SCHEDULE_TIME_FORMAT } from '../EventSchedule';
import { EventItem, EventDot, EventTime, EventTitle, EventDescription } from '../styles';
import { EventScheduleDataEvent } from '../types';
import React from 'react';

type EventScheduleItemProps = {
  event: EventScheduleDataEvent;
  onSelect?: (data: EventScheduleDataEvent) => void;
};

export const EventScheduleItem = (props: EventScheduleItemProps) => {
  const { event, onSelect } = props;

  // Custom formatting options (e.g., without seconds)
  const customTimeFormatter = new Intl.DateTimeFormat('en-US', SCHEDULE_TIME_FORMAT);
  const startDate = event.startTimeISO8601TZ ? split86012String(event.startTimeISO8601TZ) : null;
  const endDate = event.endTimeISO8601TZ ? split86012String(event.endTimeISO8601TZ) : null;

  return (
    <EventItem
      key={event.id}
      onClick={e => {
        e.stopPropagation();
        onSelect?.(event);
      }}
    >
      <EventDot />
      <EventTime>
        {startDate && `${customTimeFormatter.format(startDate.datetime)}`}
        {endDate && ` - ${customTimeFormatter.format(endDate.datetime)}`}
      </EventTime>
      <EventTitle>{event.name}</EventTitle>
      {event.description && <EventDescription>{event.description}</EventDescription>}
    </EventItem>
  );
};
